const data = [
  {
    id: 1,
    text: "home",
    url: "/",
  },

  {
    id: 3,
    text: "resources",
    url: "/resources/",
  },
  {
    id: 4,
    text: "developments",
    url: "/developments/",
  },
];

export default data;
